import React from 'react';
import { notEmpty } from 'utils/ramdaAdditions';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

const CommentsField = ({ comments }) => notEmpty(comments) ? (
    <div>
        <DefinitionHeader translate="common.comment" iconType="comment" />
        {Array.isArray(comments) ? (
            <ul className="company-comments">
                { comments.map((comment) =>(
                    <li key={comment.id} className="company-comment">
                        { comment.text }
                    </li>
                    ))
                }
            </ul>
        ) : (
            <div className="panel-view text-pre-space">
                { comments }
            </div>
        )}
    </div>
) : null;

export default CommentsField;
